import { render, staticRenderFns } from "./FeedView.vue?vue&type=template&id=61bb64a6&scoped=true"
import script from "./FeedView.vue?vue&type=script&lang=js"
export * from "./FeedView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bb64a6",
  null
  
)

export default component.exports